import { createSelector } from 'reselect';

const getShowOrderEdit = createSelector(
  [state => state.user.permissions || {}],
  permissions => !!permissions.ordercreate,
);

export default getShowOrderEdit;
